import { render, staticRenderFns } from "./BindsTooltip.vue?vue&type=template&id=8e3e0608&"
import script from "./BindsTooltip.vue?vue&type=script&lang=js&"
export * from "./BindsTooltip.vue?vue&type=script&lang=js&"
import style0 from "./BindsTooltip.vue?vue&type=style&index=0&id=8e3e0608&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports